<ng-container *ngIf="maintenance">
  <h4><p class="text-center">Onderhouds geschiedenis van {{maintenance.created | date:'d-M-y'}}</p></h4>

  <div class="row">
    <div class="col-6 col-md-2"><strong>Monteur</strong></div>
    <div class="col-6" *ngIf="maintenance.user">{{maintenance.user.name}}</div>
  </div>

  <div class="row">
    <div class="col-6 col-md-2"><strong>Werkuren</strong></div>
    <div class="col-6">{{maintenance.workhours}}</div>
  </div>

  <div class="row">
    <div class="col-6 col-md-2"><strong>Reisuren</strong></div>
    <div class="col-6">{{maintenance.travelhours}}</div>
  </div>

  <div class="row">
    <div class="col-6 col-md-2"><strong>Kilometers</strong></div>
    <div class="col-6">{{maintenance.distance}}</div>
  </div>

  <h4><p class="text-center">Machines</p></h4>

  <p-dataTable [value]="maintenance.machinemaintenances" [rows]="10" [paginator]="true" [pageLinks]="5"
               scrollable="true" selectionMode="single" [(selection)]="selectedMaintenance">
    <p-column field="machine.name" header="Naam" [sortable]="true"></p-column>
    <p-column field="machine.type" header="Type" [sortable]="true"></p-column>
    <p-column field="machine.serial" header="Serienummer" [sortable]="true"></p-column>
  </p-dataTable>
</ng-container>



// WEBPACK FOOTER //
// ./src/app/pages/maintenance/details/maintenance.details.component.html